module.exports = __webpack_public_path__ + "img/flagge-portugal.9e1498c2.jpg";